<template>
  <div>
    <template v-if="isNewTherapies">
      <template
          v-for="(item, index) in incidentData.therapies"
      >
        <v-row v-bind:key="'therapy_field_row_' + index ">
          <v-col
              sm="6"
              class="text-right"
          >
            <span class="field-name">Therapy{{ index + 1 }}</span>
          </v-col>
          <v-col
              sm="6"
              class="text-left"
          >
          <span>
            {{ item.therapy || '-' }}
          </span>
          </v-col>
        </v-row>
        <v-row v-bind:key="'tmnumber_field_row_' + index ">
          <v-col
              sm="6"
              class="text-right"
          >
            <span class="field-name">TMNumber{{ index + 1 }}</span>
          </v-col>
          <v-col
              sm="6"
              class="text-left"
          >
          <span>
            {{ item.tm || '-' }}
          </span>
          </v-col>
        </v-row>
      </template>
    </template>
    <template
        v-for="number in 10"
        v-else
    >
      <v-row v-bind:key="'therapy_field_row_' + number ">
        <v-col
            sm="6"
            class="text-right"
        >
          <span class="field-name">Therapy{{ number }}</span>
        </v-col>
        <v-col
            sm="6"
            class="text-left"
        >
          <span>
            {{ incidentData['TR_Therapy' + number] || '-' }}
          </span>
        </v-col>
      </v-row>
      <v-row v-bind:key="'tmnumber_field_row_' + number ">
        <v-col
            sm="6"
            class="text-right"
        >
          <span class="field-name">TMNumber{{ number }}</span>
        </v-col>
        <v-col
            sm="6"
            class="text-left"
        >
          <span>
            {{ incidentData['TR_TMNumber' + number] || '-' }}
          </span>
        </v-col>
      </v-row>
    </template>
  </div>
</template>
<script>
export default {
  name: 'TherapiesFields',
  props: {
    incidentData: {
      type: Object,
    },
  },
  computed: {
    isNewTherapies() {
      return Object.prototype.hasOwnProperty.call(
        this.incidentData,
        'therapies',
      );
    },
  },
};
</script>
